<template>
  <v-layout
    row
    justify-center
  >
    <v-dialog
      v-model="value"
      fullscreen
      hide-overlay
      persistent
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar
          dark
          color="gradiente"
        >
          <v-btn
            icon
            dark
            @click="close"
          >
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>Editar</v-toolbar-title>
        </v-toolbar>
        <v-container
          fluid
          style="max-height: 93vh;"
          class="scrollDesign"
        >
          <v-layout
            row
            wrap
          >
            <v-flex
              xs12
              sm12
              xl12
              class="scrollDesign"
            >
              <!-- <v-subheader>Datos generales</v-subheader> -->
              <span class="title-edit">Datos generales</span>
              <v-container 
                class="py-0" 
                style="margin: 0% !important;" 
              >
                <v-layout row>
                  <v-flex
                    xs12
                    sm6
                    md6
                  >
                    <v-textarea
                      label="Título"
                      :value="notice.title"
                      v-model="noticeForm.title"
                      name="name"
                      :error-messages="titleErrors"
                      rows="1"
                      row-height="24"
                      auto-grow
                      :disabled="editTitle"
                    />
                    <!-- :disabled="" -->
                  </v-flex> 
                  <v-flex
                    xs12
                    sm3
                    md3
                  />
                  <v-flex
                    xs12
                    sm3
                    md3
                  >
                    <v-checkbox
                      v-if="notice.confirm === 'S'"
                      v-model="noticeForm.sentToSchedule"
                      label="Programar"
                      class="black-label"
                      style="color: red !important; background-color: black; width: 0%"
                    />
                  </v-flex>
                </v-layout>  
                <v-layout row>
                  <v-flex
                    xs12
                    sm6
                    md6
                  >
                    <!-- <v-text-field label="Título" v-model="notice.title" outline :error-messages="titleErrors" style=" margin-top: 25px;" :disabled="editTitle"></v-text-field> -->
                    <div class="label-input">
                      Descripción:
                    </div>
                    <!-- <p v-if="showDescriptionText">{{notice.description}}</p> -->
                    <v-form
                      lazy-validation
                      @submit.prevent="next"
                    >
                      <v-textarea
                        :value="notice.description"
                        v-model="noticeForm.description"
                        :error-messages="descriptionErrors"
                        id="descriptionField"
                        outline
                        placeholder="Recuerda añadir en este espacio toda la información del comunicado, como objetivo del comunicado, lugar, horario, etc."
                        :disabled="editDescription"
                        rows="10"
                      />
                    </v-form>
                  </v-flex>
                  <v-flex
                    xs12
                    sm6
                    md6
                  />
                </v-layout>
              </v-container>
                    
              <!-- FECHAS DE INICIO Y FIN DE COMUNICADO> -->
              <!-- se pueden editar cuando el estatus es guardado o programado -->
              <v-list
                three-line
                v-show="notice.confirm == 'S' || notice.confirm == 'A'"
              >
                <v-list-tile avatar>
                  <v-list-tile-avatar>
                    <img :src="require('@/assets/notices/SKLB-Evento.png')">
                  </v-list-tile-avatar>
                  <v-list-tile-content>
                    <DateTimePicker
                      :min="getMinDate"
                      :error-messages="dateStartErrors"
                      v-model="noticeForm.startDate"
                      title-date="Fecha de inicio"
                      title-time="Hora de inicio"
                    />
                  </v-list-tile-content>
                </v-list-tile>
                <v-list-tile avatar>
                  <v-list-tile-avatar>
                    <img :src="require('@/assets/notices/SKLB-Evento.png')">
                  </v-list-tile-avatar>
                  <v-list-tile-content>
                    <DateTimePicker
                      :min="getMinEndDate"
                      :error-messages="dateEndErrors"
                      v-model="noticeForm.endDate"
                      title-date="Fecha de término"
                      title-time="Hora de término"
                    />
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>
              <v-list
                three-line
                v-show="notice.type == 'E' && ( notice.confirm == 'I' || notice.confirm == 'P')"
              >
                <!-- Dates tile -->
                <span class="labelTip2">Fechas de evento</span>
                <v-list-tile>
                  <v-list-tile-avatar>
                    <img :src="require('@/assets/notices/SKLB-Evento.png')">
                  </v-list-tile-avatar>
                  <v-list-tile-content>
                    <!-- <v-list-tile-title>Fechas</v-list-tile-title> -->
                    <v-list-tile-sub-title>
                      <span>
                        <strong>Inicio:</strong>
                        {{ notice.startDate | dateFormat2 }}
                      </span>
                      <span v-if="notice.endDate != null"> | </span>
                      <span v-if="notice.endDate != null">
                        <strong>Término:</strong>
                        {{ notice.endDate | dateFormat2 }}
                      </span>
                    </v-list-tile-sub-title>
                    <v-list-tile-sub-title>
                      <span v-if="notice.type == 'E'">
                        <strong>Fecha de inicio de evento:</strong>
                        {{ this.notice.startEventDate | dateFormat2 }}
                      </span>
                    </v-list-tile-sub-title>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>


              <!-- <v-subheader>Acerca del comunicado</v-subheader> -->
              <span class="title-edit">Acerca del comunicado</span>
              <!-- Current images -->
              <v-container
                fluid
                grid-list-xs
              >
                <v-layout
                  wrap
                  row
                  justify-center
                >
                  <v-flex
                    xs12
                    sm6
                    md6
                  >
                    <NoticeImage 
                      v-model="noticeForm.imageStorage"
                      :type="1" 
                    />
                  </v-flex>
                  <v-flex
                    xs12
                    sm6
                    md6
                  />
                </v-layout>
              </v-container>
              <!-- Current images -->

              <!-- <v-subheader>Documentos anexados</v-subheader> -->
              <v-container 
                fluid
                grid-list-xs
              >
                <v-flex
                  xs12
                  sm6
                  md6
                >
                  <v-chip
                    v-for="(n, key) in noticeForm.files"
                    :key="key"
                    download="o ficheirinho de tostas.pdf"
                    v-show="n.enable"
                    close
                    @input="remove(n, key)"
                  >
                    <strong>{{ n.name }}</strong>&nbsp;
                    <span>{{ (n.size/(1024*1024)).toFixed(2)+"Mb" }}</span>&nbsp;
                  </v-chip>
                  
                  <v-flex
                    xs12
                    class="mt3"
                  />
                  
                  <!-- File picker -->
                  <FileAttachment @selected-file="onSelectedFile" />
                </v-flex>
                <v-flex
                  xs12
                  sm6
                  md6
                />
                <!-- File picker -->
              </v-container>
              <v-layout>
                <v-flex
                  xs12
                  sm6
                  md6
                >
                  <type-statement-selector
                    :v="$v.noticeForm"
                    :min="getMinEventDate"
                    :max="getMaxEventDate"
                    :type="noticeForm.type"
                    :assistanceRequired="noticeForm.assistanceRequired"
                    :attendanceStudentRequired="noticeForm.attendanceStudentRequired"
                    :confirmParent="noticeForm.confirmParent"
                    :startEventDate="noticeForm.startEventDate"
                    :endDate="noticeForm.endDate"
                    :startDate="noticeForm.startDate"
                    :enabled="permitEditTypeNotice"
                    :isEdit="true"
                    @type-selected="cambiaTipo"
                    @confirm-parent-change="confirmParentChange"
                    @assistence-requiered-change="assistenceRequieredChange"
                    @attendance-student-required-change="attendanceStudentRequiredChange"
                    @start-event-date-change="startEventDateChange"
                  />
                </v-flex>
                <v-flex
                  xs12
                  sm6
                  md6
                />
              </v-layout>
              <!-- NOTIFICADOS -->
              <v-layout class="mt-3">
                <v-flex
                  xs12
                  sm11
                  md11
                  v-if="editAudience == false"
                >
                  <v-layout
                    row
                    wrap
                    justify-space-around
                    scroll-design
                    style="max-height: 520px;"
                  >
                    <v-flex
                      xs12
                      sm4
                      md4
                      v-if="notice.institutional"
                    >
                      <v-alert
                        style="border-radius:33px;"
                        :value="true"
                        type="info"
                        color="gradiente"
                      >
                        Toda la institución será notificada
                      </v-alert>
                    </v-flex>
                    <v-flex
                      xs12
                      sm3
                      md3
                      v-if="notice.levels.length > 0"
                    >
                      <v-list
                        subheader
                        two-line
                      >
                        <v-subheader key="subheader">
                          Niveles
                        </v-subheader>
                        <v-slide-y-transition
                          class="two-line subheader"
                          group
                        >
                          <v-list-tile
                            avatar
                            class="pa-0 mb-3 elevation-1 grey lighten-5 list-group-item item"
                            style="border-radius: 5px;"
                            v-for="element in notice.levels"
                            :key="element.id"
                          >
                            <v-list-tile-avatar>
                              <v-img :src="require('@/assets/panel/home/SKLB-Niveles.png')" />
                            </v-list-tile-avatar>
                            <v-list-tile-content>
                              <v-list-tile-title v-text="element.typeLevel" />
                            </v-list-tile-content>
                          </v-list-tile>
                        </v-slide-y-transition>
                      </v-list>
                    </v-flex>
                    <v-flex
                      xs12
                      sm3
                      md3
                      v-if="notice.groups.length > 0"
                    >
                      <v-list
                        subheader
                        two-line
                      >
                        <v-subheader key="subheader">
                          Grupos
                        </v-subheader>
                        <v-slide-y-transition
                          class="two-line subheader"
                          group
                        >
                          <v-list-tile
                            avatar
                            class="pa-0 mb-3 ml-2 elevation-1 grey lighten-5 list-group-item item"
                            style="border-radius: 5px;"
                            v-for="element in notice.groups"
                            :key="element.id"
                          >
                            <v-list-tile-avatar>
                              <v-img :src="require('@/assets/panel/home/SKLB-Niveles.png')" />
                            </v-list-tile-avatar>
                            <v-list-tile-content>
                              <v-list-tile-title v-text="element.grade + ' ' + element.group" />
                              <v-list-tile-sub-title v-text="element.level.typeLevel" />
                            </v-list-tile-content>
                          </v-list-tile>
                        </v-slide-y-transition>
                      </v-list>
                    </v-flex>
                    <!-- students -->
                    <v-flex
                      xs12
                      sm3
                      md3
                      v-if="notice.students.length > 0"
                    >
                      <v-list
                        subheader
                        two-line
                      >
                        <v-subheader key="subheader">
                          Alumnos
                        </v-subheader>
                        <v-slide-y-transition
                          class="two-line subheader"
                          group
                        >
                          <v-list-tile
                            avatar
                            class="pa-0 mb-3 ml-2 elevation-1 grey lighten-5 list-group-item item"
                            style="border-radius: 5px;"
                            v-for="element in notice.students"
                            :key="element.id"
                          >
                            <v-list-tile-avatar>
                              <v-img :src="require('@/assets/panel/home/SKLB-Alumnos.png')" />
                            </v-list-tile-avatar>
                            <v-list-tile-content>
                              <v-list-tile-title v-text="element.firstName + ' ' + element.lastName" />
                              <v-list-tile-sub-title
                                v-text="element.level.typeLevel + ' ' + element.gg.grade + ' ' + element.gg.group"
                              />
                            </v-list-tile-content>
                          </v-list-tile>
                        </v-slide-y-transition>
                      </v-list>
                    </v-flex>
                    <!-- colaboradores -->
                    <v-flex
                      xs12
                      sm3
                      md3
                      v-if="notice.employeeAudience.length > 0"
                    >
                      <v-list
                        subheader
                        two-line
                      >
                        <v-subheader key="subheader">
                          Colaboradores
                        </v-subheader>
                        <v-slide-y-transition
                          class="two-line subheader"
                          group
                        >
                          <v-list-tile
                            avatar
                            class="pa-0 mb-3 ml-2 elevation-1 grey lighten-5 list-group-item item"
                            style="border-radius: 5px;"
                            v-for="element in notice.employeeAudience"
                            :key="element.id"
                          >
                            <v-list-tile-avatar>
                              <v-img :src="require('@/assets/panel/home/SKLB-Colabordores.png')" />
                            </v-list-tile-avatar>
                            <v-list-tile-content>
                              <v-list-tile-title v-text="element.name + ' ' + element.lastName" />
                              <!-- <v-list-tile-sub-title
                                v-text="element.level.typeLevel + ' ' + element.gg.grade + ' ' + element.gg.group"
                              /> -->
                            </v-list-tile-content>
                          </v-list-tile>
                        </v-slide-y-transition>
                      </v-list>
                    </v-flex>
                    <!-- subgrupos -->
                    <v-flex
                      xs12
                      sm3
                      md3
                      v-if="noticeForm.subgroups.length > 0"
                    >
                      <v-list
                        subheader
                        two-line
                      >
                        <v-subheader key="subheader">
                          Subgrupos
                        </v-subheader>
                        <v-slide-y-transition
                          class="two-line subheader"
                          group
                        >
                          <v-list-tile
                            avatar
                            class="pa-0 mb-3 ml-2 elevation-1 grey lighten-5 list-group-item item"
                            style="border-radius: 5px;"
                            v-for="element in noticeForm.subgroups"
                            :key="element.id"
                          >
                            <v-list-tile-avatar>
                              <v-img :src="require('@/assets/panel/home/SKLB-Grupos.png')" />
                            </v-list-tile-avatar>
                            <v-list-tile-content>
                              <v-list-tile-title v-text="element.name + ' '" />
                              
                              <!-- element.level.typeLevel -->
                              <!-- <v-list-tile-sub-title
                                v-text="element.level.typeLevel + ' ' + element.gg.grade + ' ' + element.gg.group"
                              /> -->
                            </v-list-tile-content>
                          </v-list-tile>
                        </v-slide-y-transition>
                      </v-list>
                    </v-flex>
                    <v-flex
                      xs12
                      sm1
                      md1
                      d-flex
                      class="align-center justify-center"
                    >
                      <v-icon
                        style="height: 10px !important"
                        color="black"
                        @click="editAudience = true"
                        v-if="noticeForm.confirm != 'I'"
                      >
                        mode_edit
                      </v-icon>
                    </v-flex>
                    <v-flex
                      xs12
                      sm7
                      md7
                    />
                  </v-layout>
                </v-flex>
                <!-- AUDIENCIA -->
                <v-flex
                  xs11
                  sm11
                  md11
                  v-else
                  class="mb-5"
                >  
                  <NoticeBroadcast
                    :noticeFormEdit="noticeForm" 
                    :cancel="flags.cancel"
                    :section="'COMMUNITY'"
                    @typeChange="typeChange"
                    @selected="selectionAudiency"
                  />
                </v-flex>
                <v-flex
                  xs11
                  sm1
                  md1
                  class="mt-3"
                > 
                  <v-icon
                    color="primary"
                    @click="saveNewAudience"
                    v-if="editAudience"
                    style="width: 50%; margin-top: 10px"
                  >
                    save
                  </v-icon>
                  <v-icon
                    color="primary"
                    @click="editAudience = false"
                    v-if="editAudience"
                    style="width: 50%; margin-top: 10px"
                  >
                    cancel
                  </v-icon>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex offset-md5 />
            <v-flex
              xm12
              md2
            >
              <div
                v-if="isUpdated"
              >
                <!-- btn dinamico -->
                <v-btn  
                  small
                  color="black"
                  dark 
                  @click="updateNotice2"
                > 
                  {{ noticeForm.sentToSchedule == true ? "Programar" : "Guardar" }}
                </v-btn>
              </div>
            </v-flex>
            <v-flex offset-md3 />
            <v-flex md2>
              <v-btn
                small
                color="primary"
                dark
                @click="close"
              >
                Cancelar
              </v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card>
    </v-dialog>
    <loading
      v-model="flags.loading"
      text="Trabajando"
    />
    <success
      v-model="toast.success"
      text="Operación exitosa"
    />
    <error
      v-model="toast.failed"
      text="Ups ocurrió un error"
    />
    <error
      v-model="errors.maxExceeded.show"
      :text="errors.maxExceeded.message"
    />
    <error
      v-model="errors.wrongImage.show"
      :text="errors.wrongImage.message"
    />
    <error
      v-model="toast.error"
      :text="errorUpdate"
    />
  </v-layout>
</template>

<script>
import moment from "moment";
import { required } from "vuelidate/lib/validators";
import loading from "../Dialogs/Loading";
import success from "../Dialogs/Success";
import error from "../Dialogs/Error";
import DateTimePicker from "../Sections/Notices/Tools/DateTimePicker2";
// import VueTimePickerTool from "../../Notices/Tools/VueDateTimePicker";
import NoticeImage from "../../components/Sections/Notices/NoticesImage3";
import FileAttachment from "../Tools/FileAttachment2";
import NoticeBroadcast from "../Tools/Audience";
import TypeStatementSelector from "../../components/Tools/TypeStatementSelector.vue";

const isEqual = (a, b) => JSON.stringify(a) === JSON.stringify(b);
const copy = (value) => JSON.parse(JSON.stringify(value));

export default {
  components: {
    DateTimePicker,
    FileAttachment,
    NoticeBroadcast,
    loading,
    success,
    error,
    NoticeImage,
    TypeStatementSelector
  },
  props: ["value", "notice"],
//   mounted(){
//       this.setStatusInputs();
//   },
  mounted() {
     this.today = new Date().toLocaleDateString("sv-SE"); 
     this.hour = new Date().toLocaleTimeString("sv-SE",{hour: '2-digit', minute:'2-digit'});

   },
  filters: {
    noticeTypeFilter: function(type) {
      switch (type) {
        case "A":
          return "Aviso";
        case "E":
          return "Evento";
        case "P":
          return "Permiso";
        case "R":
          return "Reporte";
      }
    },
    dateFormat(value) {
      return moment(String(new Date(value))).format("DD/MM/YYYY");
    },
    dateFormat2(value) {
      return moment(String(new Date(value))).format("DD/MM/YYYY HH:mm");
    }
  },
  validations: {
    noticeForm: {
      type: {},
      title: { required },
      description: { required },
      startDate: { required },
      endDate: {
        validateDateEnd() {
          if (this.noticeForm.endDate) {
            return this.noticeForm.startDate < this.noticeForm.endDate
              ? true
              : false;
          }
          return true;
        }
      },
      startEventDate: { 
        validateDateStartEvent() {
          if (this.noticeForm.startEventDate) {
            if (this.noticeForm.startDate <= this.noticeForm.startEventDate && 
                this.noticeForm.startEventDate < this.noticeForm.endDate) {
                  return true
            }else{
              return false
            }
          }
          return true;
        }, 
        required
      },
    }
  },
  data: () => ({
    noticeFormUpdateCopy: null,
    noticeForm: {
      startDate: "",
      endDate: "",
      img: [],
      deletedImageStorage: [],
      levels: [],
      groups: [],
      subgroups: [],
      students: [],
      institutional: [],
      typeBroadcast: "",
      assistanceRequired: "",
      authParentRequired:"",
      confirmParent:"",
      //campos nueva version al editar comunicado
      sentToSchedule: false,
      resetReceptions:false, 
      attendanceStudentRequired: false,
      employeeAudience:[],
    },
    statusNotice : "", 
    flags: {
      loading: false,
      cancel: false

    },
    toast: {
      failed: false,
      success: false,
      error: false
    },
    modals: {
      image: false
    },
    errors: {
      maxExceeded: {
        show: false,
        message: ""
      },
      wrongImage: {
        show: false,
        message: ""
      }
    },
    editTitle: false,
    editDescription: false,
    editStartDate : false,
    editAudience: false,
    editTypeNotice:false,
    levTst:[],
    noticeTem: {
      startDate: "",
      endDate: "",
      img: [],
      deletedImageStorage: [],
      levels: [],
      groups: [],
      subgroups: [],
      students: [],
      institutional: [],
      typeBroadcast: "",
      assistanceRequired: "",
      authParentRequired:"",
      confirmParent:"",
      //campos nueva version al editar comunicado
      sentToSchedule: false,
      resetReceptions:false, 
      attendanceStudentRequired: false,
      employeeAudience:[],
    },
    audienceEdit:[],
    errorUpdate: "",
    isUpdated: false,
    typeUpdate: ""
  }),
  watch: {
    noticeForm: {
      handler(value, oldValue) {
        this.$v.noticeForm.title.$touch();
        this.$v.noticeForm.description.$touch();
        //validando inputs de fechas del evento
        this.$v.noticeForm.startDate.$touch();
        this.$v.noticeForm.endDate.$touch();
        this.$v.noticeForm.startEventDate.$touch();
        if (this.noticeForm.type === 'R'){
          this.noticeForm.confirmParent = true
        }
        if(value.id && !oldValue.id){
          this.noticeFormUpdateCopy = copy(value)
        }
        if(!value.id){
          this.noticeFormUpdateCopy = null
        }
        this.isUpdated = !isEqual(this.noticeFormUpdateCopy, value)
      },
      deep: true,
    },
    notice() {
      console.log(this.notice);
      this.noticeForm = this.notice;
      this.noticeForm.startDate = new Date(this.notice.startDate);
      //inicio
      this.noticeTem.startDate = new Date(this.notice.startDate);
      //fecha final
      this.noticeTem.endDate = new Date(this.notice.endDate);
      this.noticeTem.startEventDate = new Date(this.notice.startEventDate);

      if (this.notice.endDate != null) {
        this.noticeForm.endDate = new Date(this.notice.endDate);
      }
      if (this.notice.img == null || this.notice.img.length == 0) {
        this.noticeForm.img = [];
      }
      if (this.notice.imageStorage) {
        // cloning array
        this.noticeForm.imageStorage = this.notice.imageStorage.filter(el => !!el);
      } else {
        this.noticeForm.imageStorage = [];
      }
      this.noticeForm.deletedImageStorage = [];

      if (this.notice.files) {
        this.noticeForm.files = this.notice.files.filter(el => !!el);
      }

      //status
      this.statusNotice = this.notice.confirm;

      this.setStatusInputs();
      this.setupDataAudience();
    }
  },
  methods: {
    setupDataAudience() {
      if (this.notice.institutional) {
        this.notice.levels = []
        this.notice.groups = []
        this.notice.students = []
        this.notice.employeeAudience = []
        this.notice.subgroups = []
      }else if (this.notice.levels.length > 0){
        this.notice.groups = []
        this.notice.students = []
        this.notice.employeeAudience = []
        this.notice.subgroups = []
      }else if (this.notice.groups.length > 0){
        this.notice.levels = []
        this.notice.students = []
        this.notice.employeeAudience = []
        this.notice.subgroups = []
      }else if (this.notice.students.length > 0){
        this.notice.levels = []
        this.notice.groups = []
        this.notice.employeeAudience = []
        this.notice.subgroups = []
      }else if (this.notice.employeeAudience.length > 0){
        this.notice.levels = []
        this.notice.groups = []
        this.notice.students = []
        this.notice.subgroups = []
      }else if (this.notice.subgroups.length > 0){
        this.notice.levels = []
        this.notice.groups = []
        this.notice.students = []
        this.notice.employeeAudience = []
      }
    },
    confirmParentChange(event){
      this.noticeForm.confirmParent = event
    },
    assistenceRequieredChange(event){
      this.noticeForm.assistanceRequired = event
    },
    attendanceStudentRequiredChange(event){
      this.noticeForm.attendanceStudentRequired = event
    },
    startEventDateChange(event){
      this.noticeForm.startEventDate = new Date(event).getTime()
    },
    cambiaTipo(e){
      this.noticeForm.type=e;
    },
    close() {
      this.noticeForm = {
        levels: [],
        files: [],
        //reiniciar subgrupos y audiencia
      };
      this.$emit("input", !this.value);
    },
    deleteImage(imageStorage, index) {
      if (!this.noticeForm.imageStorage) return;
      this.noticeForm.imageStorage.splice(index, 1);
      if (!this.noticeForm.deletedImageStorage) {
        this.noticeForm.deletedImageStorage = [];
      }
      this.noticeForm.deletedImageStorage.push(imageStorage.id);
    },
    onSelectedFile(file) {
      if (!this.noticeForm.files) {
        this.noticeForm.files = [];
      }

      file.enable = true;
      this.noticeForm.files.push(file);
      this.$forceUpdate();
    },
    updateNotice() {
      this.$v.noticeForm.$touch();
      if (!this.$v.noticeForm.$invalid) {
        this.flags.loading = true;
        var notice = {
          id: this.noticeForm.id,
          title: this.noticeForm.title,
          description: this.noticeForm.description,
          startDate: this.noticeForm.startDate.getTime(),
          endDate: this.noticeForm.endDate ? this.noticeForm.endDate.getTime() : null,
          imageStorage: this.noticeForm.imageStorage,
          deleteImages: this.noticeForm.deletedImageStorage,
          assistanceRequired: this.noticeForm.assistanceRequired,
          authParentRequired:this.noticeForm.authParentRequired,
          confirmParent:this.noticeForm.confirmParent,
          files: this.noticeForm.files,
          
         
         
        };

        this.$store
          .dispatch("notice/updateNotice", notice)
          .then(() => {
            this.close();
            this.flags.loading = false;
            this.toast.success = true;
          })
          .catch(() => {
            this.flags.loading = false;
            this.toast.failed = true;
          });
      }
    },
    isValidForm(){
      if(this.noticeForm.type === 'E'){
        
        if(this.$v.noticeForm.startEventDate.$invalid){
          return false
        }
      }
      if (this.$v.noticeForm.title.$invalid){
        return false
      }
      if (this.$v.noticeForm.description.$invalid){
        return false
      }
      if (this.$v.noticeForm.startDate.$invalid){
        return false
      }
      if (this.$v.noticeForm.endDate.$invalid){
        return false
      }
      return true
    },
    updateNotice2() {
      this.$v.noticeForm.$touch();
      if (this.isValidForm()) {
        this.flags.loading = true;

        //antes de actualizar se hace la evaluación de los campos que se mandaron, primero filtrando por status donde interesa que van a resetearse los valores
          //cuando el estatus está programado pede editar todo lo del status guardado, 
          //por lo tanto si edito las fechas del evento del comunicado se deberian reiniciar  los contadores
          console.log("Actualizando comunicado revisando..."+this.noticeForm.type);
          if(this.noticeForm.type=='E' && (this.noticeForm.confirm=='A' || this.noticeForm.confirm=='S')){
            
            if(this.noticeForm.startDate.toString() != this.noticeTem.startDate.toString()){
              console.log("cambio fecha de inicio, reiniciando...");
               this.noticeForm.resetReceptions = true;
            }
             if(this.noticeForm.endDate.toString() != this.noticeTem.endDate.toString()){
              console.log("cambio fecha de final, reiniciando...");
              this.noticeForm.resetReceptions = true;
            }

            if(this.noticeForm.confirm == 'S' &&  this.noticeForm.sentToSchedule == true){
              console.log("se mando a autorizar, reiniciando");
              this.noticeForm.resetReceptions = true;
            }
          }
        
        console.log(this.noticeForm.imageStorage);
        var notice = {
          id: this.noticeForm.id,
          title: this.noticeForm.title,
          description: this.noticeForm.description,
          startDate: this.noticeForm.startDate.getTime(),
          endDate: this.noticeForm.endDate ? this.noticeForm.endDate.getTime() : null,
          imageStorage: this.noticeForm.imageStorage,
          //deleteImages: this.noticeForm.deletedImageStorage,
          files: this.noticeForm.files,
          //agregando campos de edicion de audiencia
          levels: this.noticeForm.levels,
          groups: this.noticeForm.groups,
          subgroups: this.noticeForm.subgroups,
          students: this.noticeForm.students,
          institutional: this.noticeForm.institutional,
          assistanceRequired: this.noticeForm.assistanceRequired,
          authParentRequired:this.noticeForm.authParentRequired,
          confirmParent:this.noticeForm.confirmParent,
          startEventDate:this.noticeForm.startEventDate,
          sentToSchedule : this.noticeForm.sentToSchedule,
          //mandar actualizar nuevos campor v2
          attendanceStudentRequired : this.noticeForm.attendanceStudentRequired,
          resetReceptions : this.noticeForm.resetReceptions,
          employeeAudience : this.noticeForm.employeeAudience
          
        };

        this.$store
          .dispatch("notice/updateNoticeNew", notice)
          .then(() => {
            this.close();
            this.flags.loading = false;
            this.toast.success = true;
          })
          .catch(() => {
            this.flags.loading = false;
            this.toast.failed = true;
          });
      }
    },
    remove(n, index) {
      if (n.id) {
        this.noticeForm.files[index].enable = false;
      } else {
        this.noticeForm.files.splice(index, 1);
      }
      this.$forceUpdate();
    },
    launchFilePicker() {
      this.$refs.file.click();
    },
    onFileChange(fieldName, fileList) {
      var ignoredFiles = [];
      var wrongFiles = [];
      for (let i = 0; i < fileList.length; i++) {
        const file = fileList[i];
        if (this.noticeForm.imageStorage.length + i + 1 > this.maxAllowedImages) {
          ignoredFiles.push(file.name);
        } else {
          this.toDataURL(file)
            .then(result => {
              this.noticeForm.imageStorage.push(result);
            })
            .catch(error => {
              console.log("Cannot read file", error);
              wrongFiles.push(file.name);
            });
        }
      }

      if (ignoredFiles.length === 1) {
        this.errors.maxExceeded = {
          show: true,
          message: `Se han ignorado una imagen debido a que se ha excedido el límite.`
        };
      } else if (ignoredFiles.length > 1) {
        this.errors.maxExceeded = {
          show: true,
          message: `Se han ignorado ${ignoredFiles.length} imágenes debido a que se ha excedido el límite.`
        };
      }

      if (wrongFiles.length === 1) {
        this.errors.wrongImage = {
          show: true,
          message: `No fue posible procesar la siguiente imagen: ${wrongFiles[0]}`
        };
      } else if (wrongFiles.length > 1) {
        this.errors.wrongImage = {
          show: true,
          message: `No fue posible procesar las siguientes imágenes: [${wrongFiles.join(
            ", "
          )}]`
        };
      }
    },
    toDataURL(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
      });
    },
    setStatusInputs(){
     if(this.noticeForm.confirm == "S" || this.noticeForm.confirm == "A" ){
         this.editTitle=false;
         this.editDescription=false;
         this.editStartDate=true;
         this.editAudience=false;
         this.editTypeNotice=true;
     }else if(this.noticeForm.confirm == "I"){
         this.editStartDate=false;
         this.editAudience=false;
         this.editTypeNotice=true;
     }
    },
    selectionAudiency(event) {
      this.audienceEdit = event
    },
    typeChange(type){
      this.typeUpdate = type
    },
    saveNewAudience(){
      switch (this.typeUpdate) {
          case "I":
            break;
          case "N":
            if (this.audienceEdit.levels.length === 0){
              this.errorUpdate = "Es necesario tener por lo menos un nivel"
              this.toast.error = true
              return
            }
            break;
          case "G":
            if (this.audienceEdit.ggs.length === 0){
              this.errorUpdate = "Es necesario tener por lo menos un grupo"
              this.toast.error = true
              return
            }
            break;
          case "SG":
            if (this.audienceEdit.subgroupIds.length === 0){
              this.errorUpdate = "Es necesario tener por lo menos un subgrupo"
              this.toast.error = true
              return
            }
            break;
          case "C":
            if (this.audienceEdit.webRoleIds.length === 0){
              this.errorUpdate = "Es necesario tener por lo menos un grupo de colaboradores"
              this.toast.error = true
              return
            }
            break;
          case "E":
            if (this.audienceEdit.students.length === 0){
              this.errorUpdate = "Es necesario tener por lo menos un estudiante"
              this.toast.error = true
              return
            }
            break;
        }

      this.editAudience = false
      this.noticeForm.levels = this.audienceEdit.levels;
      this.noticeForm.groups = this.audienceEdit.ggs;
      this.noticeForm.students = this.audienceEdit.students;
      this.noticeForm.institutional = this.audienceEdit.institutional;
      this.typeBroadcast = this.audienceEdit.type;
      //v2
      this.noticeForm.employeeAudience = this.audienceEdit.webRoleIds;
      this.noticeForm.subgroups = this.audienceEdit.subgroupIds;
    },
    getEntity(){
        this.$store
        .dispatch("notice/getEntidad")
        .then(response => {
         
          console.log("Entidad de firebase resuelta: "+response.data.email);
          
          this.levTst = response.data.email;
        })
        .catch(error => {
          console.log(error);
        });
    },
  },
  computed: {
    permitEditTypeNotice(){
      if(this.noticeForm.confirm === 'P' || this.noticeForm.confirm === 'S'){
        return true
      }
      return false
    },
    titleErrors() {
      const errors = [];
      if (!this.$v.noticeForm.title.$dirty) return errors;
      !this.$v.noticeForm.title.required && errors.push("Título requerido");
      return errors;
    },
    descriptionErrors() {
      const errors = [];
      if (!this.$v.noticeForm.description.$dirty) return errors;
      !this.$v.noticeForm.description.required &&
        errors.push("Descripción requerida");
      return errors;
    },
    dateStartErrors() {
      const errors = [];
      if (!this.$v.noticeForm.startDate.$dirty) return errors;
      !this.$v.noticeForm.startDate.required &&
        errors.push("Fecha de inicio obligatoria");
      return errors;
    },
    dateEndErrors() {
      const errors = [];
      if (!this.$v.noticeForm.endDate.$dirty) return errors;
      !this.$v.noticeForm.endDate.validateDateEnd &&
        errors.push("La fecha final debe ser mayor a la de inicio");
      return errors;
    },
    studentsFromNotice() {
      return this.notice.students.filter(student => {
        for (let lvl of this.notice.levels) {
          if (lvl.id == student.level.id) {
            return false;
          }
        }
        for (let gg of this.notice.groups) {
          if (gg.id == student.gg.id) {
            return false;
          }
        }
        return true;
      });
    },
    disableButton() {
      return (
        this.noticeForm.imageStorage && this.noticeForm.imageStorage.length >= this.maxAllowedImages
      );
    },
    maxAllowedImages() {
      if (!this.noticeForm.imageStorage) {
        return 5;
      }
      return 5 - this.noticeForm.imageStorage.length;
    },
    getMaxEventDate() {
      if(this.noticeForm.endDate){
        const date = new Date(this.noticeForm.endDate).toLocaleDateString("sv-SE"); 
        return date
      }
      return ""
    },
    getMinEventDate() {
      if(this.noticeForm.startDate){
        const date = new Date(this.noticeForm.startDate).toLocaleDateString("sv-SE"); 
        return date
      }
      return ""
    },
    getMinDate() {
      return new Date().toLocaleDateString("sv-SE"); 
    },
    getMinEndDate() {
      if(this.noticeForm.startDate){
        const date = new Date(this.noticeForm.startDate).toLocaleDateString("sv-SE"); 
        return date
      }
      return ""
    }
  }
};
</script>

<style>

.title-edit{
  font-size: 1.5em;
  color: rgb(163, 163, 163);
  font-weight: bold;
}

.centeras {
  display: flex;
  align-items: center;
  justify-content: center;
}

.label-input {
  font-size: 13px;
  color: #757575;
  margin-bottom: 5px;
}
</style>
